import { PayloadAction } from "@reduxjs/toolkit";
import createGenericSlice, {
    GenericState,
} from "src/helpers/createGenericSlice";
import { DailyRoomResponse } from "../../../types/api/ticket";

const initialState: GenericState<DailyRoomResponse | null> = {
    room: null,
    status: "finished",
    errorMessage: "",
};

const ticketDailySlice = createGenericSlice({
    name: "ticket/daily",
    initialState,
    reducers: {
        startMeeting(state, action: PayloadAction<{ leadId: number | null }>) {
            state.status = "loading";
        },
        meetingSuccess(state, action: PayloadAction<DailyRoomResponse>) {
            state.status = "finished";
            state.room = action.payload;
        },
        meetingFail(state, action: PayloadAction<{ message?: string }>) {
            state.status = "error";
            state.errorMessage = action.payload.message;
        },
        clearRoom(state) {
            state.room = null;
            state.errorMessage = "";
        },
    },
});

export const { startMeeting, meetingSuccess, meetingFail, clearRoom } =
    ticketDailySlice.actions;

export default ticketDailySlice.reducer;
